import React from 'react';
import { css } from 'aphrodite/no-important';
import { ICON_COMPONENT } from '../../../constants/icons';
import styles from './AddSelection.styles';

const AddSelection = props => {
  return (
    <div className={css(styles.base)}>
      <ul className={css(styles.list)}>
        {props.options &&
          props.options.map(item => {
            let Icon = ICON_COMPONENT[item.iconType];
            return (
              <li
                className={css(styles.item)}
                onClick={() => props.onClick(item)}
                key={item.value}
              >
                <Icon value={item.iconValue} styles={styles[item.iconType]} />
                {item.name}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default AddSelection;



// WEBPACK FOOTER //
// ./src/components/common/addselection/AddSelection.js